export default __webpack_public_path__ + "static/media/icon-poubelle-btn.7dd1cf8a.svg";